export default __webpack_public_path__ + "static/media/hardBrake.1b8d9a80.png";